export default function usePxUserFrontendScript() {
    return useScript({
        src: 'https://user-frontend.api.pl-x.cloud/js/widget.js',
        async: false,
        crossorigin: null,
        referrerpolicy: null,
    });
}
